<div class="prog">

  <header class="prog-head">
    <div>
      <h1>Avance de la revisión</h1>
      <p>Lo que le pedimos a Contabilidad que conteste, en los tres manuales.</p>
    </div>
  </header>

  <!-- Esqueleto con la forma de lo que llega: tres indicadores y la tabla. -->
  <ng-container *ngIf="loading">
    <div class="prog-kpis">
      <div class="prog-kpi" *ngFor="let k of [1, 2, 3]"><span class="sk-line sk-lbl"></span><span class="sk-line sk-val"></span></div>
    </div>
    <div class="prog-card">
      <div class="sk-row" *ngFor="let r of [1, 2, 3, 4, 5, 6]"></div>
    </div>
  </ng-container>

  <div class="prog-error" *ngIf="!loading && loadError">
    <i class="fa-solid fa-triangle-exclamation"></i>
    <p>{{ loadError }}</p>
  </div>

  <ng-container *ngIf="!loading && !loadError">

    <!-- Dos metas, dos números: contestar es de Contabilidad, cerrar es nuestro. -->
    <div class="prog-kpis">
      <button type="button" class="prog-kpi" [class.is-active]="filtro === 'all'" (click)="filtro = 'all'">
        <span class="lbl">Decisiones</span>
        <span class="val">{{ progress.total }}</span>
        <span class="note">en los tres manuales</span>
      </button>
      <button type="button" class="prog-kpi is-answered" [class.is-active]="filtro === 'answered'" (click)="filtro = 'answered'">
        <span class="lbl">Contestadas</span>
        <span class="val">{{ progress.answered }}</span>
        <span class="note">meta de Contabilidad</span>
      </button>
      <button type="button" class="prog-kpi is-closed" [class.is-active]="filtro === 'closed'" (click)="filtro = 'closed'">
        <span class="lbl">Cerradas</span>
        <span class="val">{{ progress.closed }}</span>
        <span class="note">las que ya resolvimos</span>
      </button>
      <button type="button" class="prog-kpi is-pending" [class.is-active]="filtro === 'pending'" (click)="filtro = 'pending'">
        <span class="lbl">Sin contestar</span>
        <span class="val">{{ pendientes }}</span>
        <span class="note">lo que falta pedir</span>
      </button>
    </div>

    <div class="prog-tabla">
      <table>
        <thead>
          <tr>
            <th style="width:76px">Clave</th>
            <!-- Acotada: los títulos son cortos y sin tope dejaba medio ancho de pantalla en
                 blanco entre la decisión y su estado. -->
            <th style="width:52%">Decisión</th>
            <th style="width:150px">Estado</th>
            <th>Última respuesta</th>
          </tr>
        </thead>

        <!-- Un cuerpo por manual: su encabezado lleva el avance, así que no hace falta ni una
             columna «Manual» repitiendo el mismo texto diez veces ni un bloque aparte. -->
        <tbody *ngFor="let grupo of grupos">
          <tr class="prog-grupo">
            <td colspan="2">
              <i [ngClass]="grupo.doc.icon"></i>
              <a [routerLink]="['/documentation', grupo.doc.slug]" (click)="$event.stopPropagation()">{{ grupo.doc.title }}</a>
            </td>
            <td colspan="2">
              <span class="prog-grupo__avance">
                <span class="prog-bar">
                  <i class="is-closed" [style.width.%]="grupo.progress.total ? grupo.progress.closed / grupo.progress.total * 100 : 0"></i>
                  <i class="is-answered" [style.width.%]="grupo.progress.total ? (grupo.progress.answered - grupo.progress.closed) / grupo.progress.total * 100 : 0"></i>
                </span>
                <b>{{ grupo.progress.answered }}/{{ grupo.progress.total }}</b>
              </span>
            </td>
          </tr>

          <tr *ngFor="let row of grupo.rows; trackBy: trackByRow" (click)="abrir(row)" [title]="'Ir a la decisión ' + row.decision.code">
            <td><span class="prog-code">{{ row.decision.code }}</span></td>
            <td class="prog-ti">{{ row.decision.title }}</td>
            <td><span class="prog-pill" [ngClass]="'is-' + row.state">{{ row.label }}</span></td>
            <td class="prog-who">
              <ng-container *ngIf="row.who; else nadie">{{ row.who }} · {{ row.when | date: 'd MMM y' }}</ng-container>
              <ng-template #nadie><span class="prog-none">Sin respuesta</span></ng-template>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <p class="prog-empty" *ngIf="!visibles.length">No hay decisiones en este estado.</p>

  </ng-container>
</div>
